var exports = {
  "Qs": "xe533113f--f14cd9--content",
  "DD": "xe533113f--f14cd9--title",
  "h_": "xe533113f--f14cd9--description",
};

module.exports = exports;
